import { Schedule } from '../programs/Types';

import { Days } from '../app/app.const';

const daysList: string[] = [
  Days.Monday.toUpperCase(),
  Days.Tuesday.toUpperCase(),
  Days.Wednesday.toUpperCase(),
  Days.Thursday.toUpperCase(),
  Days.Friday.toUpperCase(),
  Days.Saturday.toUpperCase(),
  Days.Sunday.toUpperCase()
];

export function schedulesComparator(schedule1: Schedule, schedule2: Schedule) {
  const indexDay1 = daysList.indexOf(schedule1.day.toUpperCase());
  const indexDay2 = daysList.indexOf(schedule2.day.toUpperCase());

  if (indexDay1 < indexDay2) {
    return -1;
  }
  if (indexDay1 > indexDay2) {
    return 1;
  }
  
  // Same day
  if (schedule1.startHour < schedule2.startHour) {
    return -1;
  }
  if (schedule1.startHour < schedule2.startHour) {
    return 1;
  }

  if (schedule1.startMinute < schedule2.startMinute) {
    return -1;
  }
  if (schedule1.startMinute < schedule2.startMinute) {
    return 1;
  }
  return 0;
}


// WEBPACK FOOTER //
// ./src/util/compare-util.tsx